export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
  viewCount: number;
}

export const articles: Article[] = [
  {
    slug: '2024-zuixin-gaoxiao-xuexi-ziyuan-zhengli',
    title: '2024最新高效学习资源整理——从入门到精通的全方位指南',
    excerpt: '精心整理了2024年最值得收藏的学习资源，涵盖编程、设计、语言等多个领域，帮助你在新的一年里快速提升技能水平。',
    content: `<p>在信息爆炸的时代，找到<strong>高质量的学习资源</strong>是提升效率的关键。本文为你整理了一份2024年最新、最全面的学习资源清单。</p>
<h2>编程开发类资源</h2>
<p>无论你是编程新手还是资深开发者，以下资源都值得收藏：</p>
<ul>
<li><strong>前端开发</strong>：React 19 官方文档、Tailwind CSS 实战教程、TypeScript 深入理解</li>
<li><strong>后端开发</strong>：Node.js 最佳实践、Python Django 框架、Go 语言高性能编程</li>
<li><strong>移动开发</strong>：Flutter 跨平台开发、SwiftUI 教程合集</li>
</ul>
<h2>设计创意类资源</h2>
<p>设计师不容错过的优质资源：Figma 组件库、Dribbble 灵感集合、Behance 作品展示。</p>
<h2>语言学习类资源</h2>
<p>英语、日语、韩语等多语种学习资料，听说读写全方位覆盖。</p>
<p>持续关注狠狠撸，我们将不断更新更多<strong>优质学习资源</strong>，让您的学习之路更加顺畅。</p>`,
    category: 'xuexi-jiaoyu',
    categoryName: '学习教育',
    author: '资源达人小王',
    publishDate: '2024-03-15',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20study%20workspace%20with%20laptop%20and%20books%20on%20wooden%20desk%2C%20warm%20natural%20lighting%2C%20clean%20aesthetic%2C%20editorial%20photography%2C%20soft%20shadows%2C%20organized%20shelves%20background&width=800&height=450&seq=article-learn-01&orientation=landscape',
    tags: ['学习资源', '编程教程', '在线课程', '效率工具'],
    viewCount: 15820,
  },
  {
    slug: '2024-remen-dianying-ziyuan-pan-dian',
    title: '2024热门电影资源大盘点——年度必看佳作推荐',
    excerpt: '盘点2024年最受期待的国内外电影大片，从科幻巨制到文艺佳作，一部不落的观影指南。',
    content: `<p>2024年是<strong>电影大年</strong>，国内外佳作层出不穷。本文为您盘点年度最值得关注的电影资源。</p>
<h2>国产电影推荐</h2>
<p>今年国产电影市场百花齐放，科幻、动画、现实题材均有亮眼表现。《流浪地球3》延续前作的高水准制作，《封神第二部》将神话史诗推向新高度。</p>
<h2>海外大片精选</h2>
<p>好莱坞年度巨制纷纷定档，超级英雄电影、科幻冒险、动画电影精彩纷呈。《阿凡达3》将再次刷新视觉体验的边界。</p>
<h2>小众文艺佳作</h2>
<p>独立电影和艺术片爱好者也不容错过，各大电影节获奖作品陆续上线。</p>
<p>狠狠撸为您持续追踪<strong>最新电影资源</strong>，让精彩不再错过。</p>`,
    category: 'yingshi-yule',
    categoryName: '影视娱乐',
    author: '影评人老张',
    publishDate: '2024-03-12',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20posters%20displayed%20artistically%20in%20a%20dark%20theater%2C%20warm%20golden%20spotlight%2C%20elegant%20composition%2C%20rich%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=article-movie-01&orientation=landscape',
    tags: ['电影资源', '影视推荐', '年度盘点', '观影指南'],
    viewCount: 23450,
  },
  {
    slug: 'tigao-gongzuo-xiaolv-bibeiruanjian',
    title: '提高工作效率的10款必备软件工具——职场人必看',
    excerpt: '精选10款能大幅提升工作效率的软件工具，涵盖笔记管理、项目管理、自动化处理等场景。',
    content: `<p>在快节奏的职场环境中，<strong>效率工具</strong>是拉开差距的关键。本文推荐10款经过实战验证的高效软件。</p>
<h2>笔记与知识管理</h2>
<p>Notion 全能工作空间，Obsidian 双向链接笔记，让知识管理变得井井有条。</p>
<h2>项目管理工具</h2>
<p>Linear 极简项目管理，ClickUp 全能协作平台，满足不同团队的协作需求。</p>
<h2>自动化效率工具</h2>
<p>Raycast 快速启动器，Keyboard Maestro 自动化脚本，让重复工作一键完成。</p>
<p>关注狠狠撸，获取更多<strong>实用软件推荐</strong>，让工作事半功倍。</p>`,
    category: 'ruanjian-gongju',
    categoryName: '软件工具',
    author: '效率控小李',
    publishDate: '2024-03-10',
    readTime: '12分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20multiple%20screens%20displaying%20productivity%20apps%2C%20minimal%20workspace%2C%20warm%20ambient%20light%2C%20organized%20cables%2C%20professional%20tech%20aesthetic&width=800&height=450&seq=article-software-01&orientation=landscape',
    tags: ['效率工具', '软件推荐', '职场技能', '自动化'],
    viewCount: 18930,
  },
  {
    slug: 'sheji-sucai-mianfei-wangzhan-tuijian',
    title: '设计师必备！10个免费高质量设计素材网站推荐',
    excerpt: '收集了10个提供免费高质量设计素材的网站，包括图片、图标、字体、插画等类型。',
    content: `<p>对于设计师而言，<strong>优质素材资源</strong>是创意的基石。本文整理了10个不可错过的免费素材网站。</p>
<h2>图片素材</h2>
<p>Unsplash 高质量摄影图片，Pexels 免费商用视频素材，满足各类视觉需求。</p>
<h2>图标与插画</h2>
<p>unDraw 开源插画库，IconScout 海量图标资源，让设计更加出彩。</p>
<h2>字体资源</h2>
<p>Google Fonts 开源字体库，猫啃网 中文免费字体集合，丰富你的字体选择。</p>
<p>狠狠撸持续更新<strong>设计素材资源</strong>，助力你的创意之旅。</p>`,
    category: 'sheji-sucai',
    categoryName: '设计素材',
    author: '设计师阿美',
    publishDate: '2024-03-08',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20design%20studio%20with%20color%20palettes%20and%20typography%20samples%20on%20wall%2C%20creative%20workspace%2C%20warm%20natural%20lighting%2C%20minimal%20aesthetic%2C%20professional%20interior%20photography&width=800&height=450&seq=article-design-01&orientation=landscape',
    tags: ['设计素材', '免费资源', 'UI设计', '平面设计'],
    viewCount: 12780,
  },
  {
    slug: 'gaopin-yinyue-zhuanji-tuijian-2024',
    title: '2024高品质音乐专辑推荐——耳朵的极致享受',
    excerpt: '为你精选2024年发行的优质音乐专辑，涵盖流行、摇滚、电子、古典等多种风格。',
    content: `<p>音乐是生活最好的调味剂。2024年乐坛佳作频出，本文为你推荐<strong>不容错过的音乐专辑</strong>。</p>
<h2>华语流行</h2>
<p>周杰伦新专辑延续经典风格，林俊杰全新创作令人耳目一新，华语乐坛持续发力。</p>
<h2>欧美精选</h2>
<p>Taylor Swift 再创巅峰，Billie Eilish 风格突破，欧美乐坛精彩纷呈。</p>
<h2>独立音乐</h2>
<p>小众独立音乐人带来惊喜之作，实验性音乐探索新的听觉边界。</p>
<p>狠狠撸为您搜集<strong>高品质音乐资源</strong>，让每一刻都充满旋律。</p>`,
    category: 'yinyue-yinpin',
    categoryName: '音乐音频',
    author: '乐评人小陈',
    publishDate: '2024-03-05',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20vinyl%20records%20and%20headphones%20on%20wooden%20table%2C%20warm%20moody%20lighting%2C%20retro%20aesthetic%2C%20music%20listening%20atmosphere%2C%20cozy%20interior%20photography&width=800&height=450&seq=article-music-01&orientation=landscape',
    tags: ['音乐推荐', '专辑盘点', '高品质音乐', '无损音源'],
    viewCount: 9650,
  },
  {
    slug: 'dianzishu-yuedu-pingtai-hengping',
    title: '2024主流电子书阅读平台横评——找到最适合你的那一个',
    excerpt: '对比评测 Kindle、微信读书、得到、网易蜗牛等主流电子书平台，帮你选出最佳阅读伴侣。',
    content: `<p>数字化阅读已经成为主流。面对众多<strong>电子书阅读平台</strong>，如何选择最适合自己的？本文为你详细对比。</p>
<h2>Kindle 电子书</h2>
<p>全球最大的电子书商店，资源丰富，阅读体验纯净。适合重度阅读者。</p>
<h2>微信读书</h2>
<p>社交化阅读体验，免费书籍多，与微信生态深度整合。适合碎片化阅读。</p>
<h2>得到电子书</h2>
<p>精选好书+解读服务，知识服务特色鲜明。适合追求高效学习的用户。</p>
<p>狠狠撸为您整理<strong>优质阅读资源</strong>，让阅读变得简单愉快。</p>`,
    category: 'tushu-wenxian',
    categoryName: '图书文献',
    author: '读书人老赵',
    publishDate: '2024-03-01',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20bookshelf%20and%20e-reader%20device%2C%20warm%20lamp%20light%2C%20comfortable%20armchair%2C%20minimal%20interior%2C%20peaceful%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=article-books-01&orientation=landscape',
    tags: ['电子书', '阅读平台', '数字阅读', '书籍推荐'],
    viewCount: 11230,
  },
  {
    slug: '2024-zuixin-youxi-gonglue-heji',
    title: '2024最新热门游戏攻略合集——从小白到大神的进阶之路',
    excerpt: '汇集年度热门游戏的详细攻略、隐藏技巧和高阶玩法，助你在游戏中畅通无阻。',
    content: `<p>游戏世界充满挑战与乐趣。本文为你整理<strong>2024热门游戏攻略</strong>，助你快速提升游戏水平。</p>
<h2>开放世界游戏</h2>
<p>《原神》最新版本全收集攻略，《塞尔达传说》全神庙通关指南，探索不迷路。</p>
<h2>竞技游戏</h2>
<p>《英雄联盟》新赛季上分攻略，《王者荣耀》英雄进阶技巧，助你驰骋战场。</p>
<h2>独立游戏</h2>
<p>精品独立游戏推荐及通关攻略，发现更多游戏乐趣。</p>
<p>狠狠撸持续更新<strong>游戏攻略资源</strong>，陪伴你的游戏之旅。</p>`,
    category: 'youxi-ziyuan',
    categoryName: '游戏资源',
    author: '游戏达人阿杰',
    publishDate: '2024-02-28',
    readTime: '11分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20RGB%20lighting%20and%20mechanical%20keyboard%2C%20game%20posters%20on%20wall%2C%20modern%20gaming%20room%2C%20immersive%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=article-game-01&orientation=landscape',
    tags: ['游戏攻略', '热门游戏', 'MOD资源', '游戏资讯'],
    viewCount: 20150,
  },
  {
    slug: 'jiankang-yangsheng-shenghuo-xiguan',
    title: '科学养生指南——10个简单有效的健康生活习惯',
    excerpt: '从饮食、运动、睡眠到心理调节，为你整理了一套科学实用的健康生活方案。',
    content: `<p>健康是一切的基础。本文分享<strong>科学养生的方法</strong>，这些简单易行的习惯将带来显著改变。</p>
<h2>饮食调理</h2>
<p>均衡膳食搭配原则，应季食材选择指南，让你吃出健康好气色。</p>
<h2>运动习惯</h2>
<p>适合上班族的碎片化运动方案，每天15分钟，告别亚健康。</p>
<h2>睡眠优化</h2>
<p>改善睡眠质量的实用技巧，让你每晚都能享受深度睡眠。</p>
<p>狠狠撸关注您的<strong>健康生活品质</strong>，分享更多实用百科知识。</p>`,
    category: 'shenghuo-baike',
    categoryName: '生活百科',
    author: '健康顾问小林',
    publishDate: '2024-02-25',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Healthy%20lifestyle%20scene%20with%20fresh%20fruits%20and%20yoga%20mat%20in%20bright%20room%2C%20natural%20sunlight%2C%20minimal%20interior%2C%20wellness%20aesthetic%2C%20clean%20composition%2C%20editorial%20photography&width=800&height=450&seq=article-health-01&orientation=landscape',
    tags: ['健康养生', '生活习惯', '饮食调理', '运动健身'],
    viewCount: 8760,
  },
];